import { useEffect, useRef, useState } from "react";
import { api } from "../../lib/api";

export function renderMentions(text) {
  const parts = String(text || "").split(/(@[A-Za-z(][\w.'()&-]*(?:\s[A-Z(][\w.'()&-]*){0,2})/g);
  return parts.map((p, i) => (p.startsWith("@") ? <span key={i} className="text-cyan-300 font-semibold" data-testid="mention">{p}</span> : p));
}

export function useMentions(value, setValue, ref) {
  const [sugs, setSugs] = useState([]); const [range, setRange] = useState(null);
  const timer = useRef(null);
  useEffect(() => {
    const el = ref?.current; const pos = el ? el.selectionStart : value.length;
    const before = value.slice(0, pos); const m = before.match(/@([\w.'()&-]*(?:\s[\w.'()&-]*)?)$/);
    if (!m) { setSugs([]); setRange(null); return; }
    setRange([pos - m[0].length, pos]);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => api.get("/community/mentions", { params: { q: m[1] } }).then((r) => setSugs(r.data)).catch(() => setSugs([])), 150);
    return () => clearTimeout(timer.current);
  }, [value]); // eslint-disable-line
  const pick = (s) => { if (!range) return; setValue(value.slice(0, range[0]) + `@${s.name} ` + value.slice(range[1])); setSugs([]); setRange(null); setTimeout(() => ref?.current?.focus(), 0); };
  return { sugs, pick };
}

export function MentionList({ sugs, pick }) {
  if (!sugs.length) return null;
  return (
    <div className="absolute z-30 left-0 right-0 mt-1 rounded-xl border border-slate-700 bg-[#0B0D12] shadow-xl overflow-hidden" data-testid="mention-suggestions">
      {sugs.map((s) => <button key={s.user_id} type="button" onMouseDown={(e) => { e.preventDefault(); pick(s); }} data-testid={`mention-option-${s.user_id}`} className="w-full text-left px-3 py-2 text-sm hover:bg-[#1a2234] flex items-center gap-2"><span className="w-6 h-6 rounded-full bg-slate-800 grid place-items-center text-[11px] font-bold">{s.name[0]}</span>@{s.name}</button>)}
    </div>
  );
}
